import { render, staticRenderFns } from "./InventoryItemDispatches.vue?vue&type=template&id=34a7548a&scoped=true&"
import script from "./InventoryItemDispatches.vue?vue&type=script&lang=js&"
export * from "./InventoryItemDispatches.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34a7548a",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VDialog } from 'vuetify/lib/components/VDialog';
installComponents(component, {VDialog})
